import React from 'react';
import { ReactComponent as AmericanExpress } from './americanExpress.svg';
import { ReactComponent as Visa } from './visa.svg';
import { ReactComponent as Mastercard } from './mastercard.svg';
import discoverLogo from './discover.png';


const CardLogo = (props) => {
    return (
        <div className="container container_center">
            <div className="bank">
                <Mastercard className="bank__logo" />
                <Visa className="bank__logo" />
                <img src={discoverLogo} className="bank__logo bank__logo--discover" alt="Discover"/>
                <AmericanExpress className="bank__logo" />
            </div>
        </div>
    )
}

export default CardLogo;